import { useEffect, useState } from 'react';
import { fetchAndActivate, getValue } from 'firebase/remote-config';
import { remoteConfig } from '../utils/firebase';

interface MaintenanceData {
  isMaintenance: boolean;
  message: string;
  endTime: string | null;
  loading: boolean;
}

export const useMaintenanceMode = (): MaintenanceData => {
  const [maintenanceData, setMaintenanceData] = useState<MaintenanceData>({
    isMaintenance: false,
    message: '',
    endTime: null,
    loading: true
  });

  useEffect(() => {
    const checkMaintenanceMode = async () => {
      try {
        remoteConfig.settings.minimumFetchIntervalMillis = 10000; 
        
        await fetchAndActivate(remoteConfig);
        
        const isMaintenance = getValue(remoteConfig, 'maintenance_mode').asBoolean();
        const message = getValue(remoteConfig, 'maintenance_message').asString();
        const endTime = getValue(remoteConfig, 'maintenance_end_time').asString();
        
        setMaintenanceData({
          isMaintenance,
          message,
          endTime: endTime || null,
          loading: false
        });
      } catch (error) {
        console.error('Error checking maintenance mode:', error);
        setMaintenanceData(prev => ({ ...prev, loading: false }));
      }
    };

    checkMaintenanceMode();
    
    // Optional: Set up interval to check for updates periodically
    const interval = setInterval(checkMaintenanceMode, 10000); 
    
    return () => clearInterval(interval);
  }, []);

  return maintenanceData;
};